import { createFileRoute } from '@tanstack/react-router';
import { DepartmentsPage } from '@/pages/DepartmentsPage';

export const Route = createFileRoute('/departments')({
  component: DepartmentsPage,
});
